import { createStyles } from 'antd-style';

import { flex1, flexCenter } from '../../styles/mixins';
import { ThemeColors, ThemeFont, ThemeSpaces } from '../../theme';

export const useLayoutElementsStyles = createStyles(({ token }) => ({
  flex1: flex1(),
  flexCol: {
    display: 'flex',
    flexDirection: 'column',
  },
  flexColNoOverflow: {
    '&, & > *': {
      overflow: 'hidden',
    },
  },
  flexAlignStretch: {
    alignSelf: 'stretch',
  },
  fullHeight: {
    height: '100%',
  },
  verticalDivider: {
    margin: `0 ${ThemeSpaces.SPACE_MD}px`,
  },
  // Only the `full` modifier is ever used — `sm` had no consumers.
  colVerticalDividerFull: {
    margin: 0,
    borderRight: `1px solid ${ThemeColors.COLOR_GREY6}`,
    height: '100%',
  },
  titleWithExtra: {
    marginBottom: ThemeSpaces.SPACE_NORM,
    color: ThemeColors.COLOR_GREY_BLUISH2,

    'h3.ant-typography': {
      fontFamily: ThemeFont.FONT_CONDENSED,
      fontWeight: 'bold',
      letterSpacing: '-0.33px',
      color: ThemeColors.COLOR_GREY3,
      marginBottom: 0,

      [`@media (min-width: ${token.screenLGMin}px)`]: {
        fontSize: 26,
        lineHeight: '40px',
      },
      [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
        {
          fontSize: 22,
          lineHeight: '30px',
        },
      [`@media (min-width: ${token.screenSMMin}px) and (max-width: ${token.screenSMMax}px)`]:
        {
          fontSize: 20,
          lineHeight: '20px',
        },
      [`@media (max-width: ${token.screenXSMax}px)`]: {
        fontSize: 18,
        lineHeight: '20px',
      },
    },

    '.ant-btn': {
      marginRight: ThemeSpaces.SPACE_SM,

      '&:last-child': {
        marginRight: 0,
      },
    },

    '.ant-col:last-child': {
      ...flexCenter(),
    },
  },
  doubleLine: {
    borderTop: `1px solid ${ThemeColors.COLOR_GREY8_1}`,
    borderBottom: `1px solid ${ThemeColors.COLOR_WHITE}`,
  },
  // `size-40` had no consumers — only 6/10/20/30 are ever applied.
  twoLines: {
    height: 10,
    borderTop: `1px solid ${ThemeColors.COLOR_WHITE}`,
    borderBottom: `1px solid ${ThemeColors.COLOR_GREY8_1}`,

    '&.size-6': { height: 6 },
    '&.size-10': { height: 10 },
    '&.size-20': { height: 20 },
    '&.size-30': { height: 30 },
  },
  threeLines: {
    position: 'relative',
    height: 20,
    borderTop: `1px solid ${ThemeColors.COLOR_WHITE}`,
    borderBottom: `1px solid ${ThemeColors.COLOR_WHITE}`,

    '&::before': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: 0,
      right: 0,
      borderBottom: `1px solid ${ThemeColors.COLOR_GREY8_1}`,
    },
  },
  horizontalDividerWithCircle: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
  },
  horizontalDividerWithCircleLine: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '50%',
    height: 0,
    borderTop: `1px solid ${ThemeColors.COLOR_GREY9}`,
  },
  horizontalDividerWithCircleCircle: {
    position: 'relative',
    width: 50,
    height: 50,
    backgroundColor: ThemeColors.COLOR_WHITE,
    border: `1px solid ${ThemeColors.COLOR_GREY9}`,
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: ThemeColors.COLOR_GREY3,
    fontSize: 14,
    fontFamily: ThemeFont.FONT_FAMILY2,
  },
}));
